{
  "GenericAdminFilterLanguage_CME_LABEL": "CME",
  "GenericAdminFilterLanguage_TELSYS_LABEL": "Telephony Server",
  "GenericAdminFilterLanguage_PARTITION_LABEL": "Partition",
  "GenericAdminFilterLanguage_CRM_TYPE_LABEL": "CRM Type",
  "GenericAdminFilterLanguage_INCLUDE_CHILD_CMES_LABEL": "Include Child CME Items",
  "GenericAdminFilterLanguage_SEARCH_LABEL": "Search",
  "GenericAdminFilterLanguage_OPTION_ALL_LABEL": "All",
  "GenericAdminFilterLanguage_OPTION_ANY_LABEL": "Any",
  "GenericAdminFilterLanguage_OPTION_NONE_LABEL": "None",
  "GenericAdminFilterLanguage_PLEASE_SELECT_OPTION_TO_SHOW_RESULTS": "Please select an option to show results.",
  "NAME": "GenericAdminFilterLanguage"
}
